<div class="col" *ngIf="data!=null">
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th *ngFor="let col of columns"
                        [class.text-end]="col.align === 'end'">
                    {{ col.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of data">

                    <!-- PRODUCTO -->
                    <td class="fw-bold">
                    {{ row.productName }}
                    </td>

                    <!-- CAMIONES DINÁMICOS -->
                    <td *ngFor="let container of containers"
                        class="text-end">
                    {{ getQty(row, container) | number:'1.0-0' }}
                    </td>

                    <!-- TOTAL POR PRODUCTO -->
                    <td class="text-end fw-bold">
                    {{ row.totalQty | number:'1.0-0' }}
                    </td>

                </tr>

                <!-- FILA TOTAL GENERAL -->
                <!-- <tr class="table-secondary fw-bold">
                    <td>TOTAL</td>

                    <td *ngFor="let container of containers"
                        class="text-end">
                    {{ getTotalByContainer(container) | number:'1.0-0' }}
                    </td>

                    <td class="text-end">
                    {{ getGrandTotal() | number:'1.0-0' }}
                    </td>
                </tr> -->
            </tbody>
        </table>
    </div>
</div>